import {HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {Credentials} from 'src/app/domain/core/credentials.model';

export  const credentialsInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    // Set auth header
    const credentials = localStorage.getItem(Credentials.credentialsKey);
    if (credentials) {
      req = req.clone({
        setHeaders: {
          Authorization: credentials
        }
      });
    }

    return next(req);
}
